import { MessageDescriptor } from 'react-intl';

import messages from './messages';
import { DynamicApproverType } from './ruleForm';

/**
 * What each dynamic approver type reads as wherever a rule names it: its chip
 * in the editor and its entry in the rules table.
 *
 * A request reads the server's `source_label` instead, recorded at submission,
 * so a later edit to the rule leaves the request's wording as it was.
 */
export const DYNAMIC_APPROVER_LABELS: Record<
  DynamicApproverType,
  MessageDescriptor
> = {
  opening_owner: messages.openingOwnerApprover,
};
